import ComposeViewState from '../store/schema/ComposeViewState';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import { action } from 'satcheljs/lib/legacy';

const removeInfoBarMessageInCompose = action('removeInfoBarMessageInCompose')(
    function removeInfoBarMessageInCompose(
        viewState: ComposeViewState,
        messageIds?: string | string[]
    ) {
        if (!viewState.infoBarIds || !viewState.infoBarIds.length) {
            return;
        }

        if (messageIds) {
            messageIds = Array.isArray(messageIds) ? messageIds : [messageIds];
            messageIds.forEach((messageId: string) => {
                removeInfoBarMessage(viewState, messageId, viewState.composeId);
            });
        } else {
            viewState.infoBarIds.forEach((messageId: string) => {
                removeInfoBarMessage(viewState, messageId, viewState.composeId);
            });
        }
    }
);

export default removeInfoBarMessageInCompose;
